import { render, staticRenderFns } from "./stockSelect.vue?vue&type=template&id=679ff39a&scoped=true"
import script from "./stockSelect.vue?vue&type=script&lang=js"
export * from "./stockSelect.vue?vue&type=script&lang=js"
import style0 from "./stockSelect.vue?vue&type=style&index=0&id=679ff39a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ff39a",
  null
  
)

export default component.exports